module.exports = __webpack_public_path__ + "img/floorboard-desktop-contextmenu.47085dd1.jpg";